<template>
  <div style="background: transparent" :style="{position: 'absolute',top: 0,bottom: 0, 'overflow-y': 'scroll', right: 0, left: 0,'overflow-x': 'hidden'}">
    <v-card class="cardStyle"
            max-width="400" style=" margin: auto;margin-top: 10px">
      <v-card-title style="justify-content: center">
        {{ $t('Information of AMM Liquidity') }}
      </v-card-title>
      <v-divider style="background: black" />
      <v-row>
        <v-col cols="6" style="text-align: right">
          {{ $t('Liquidity') }}:
        </v-col>
        <v-col style="text-align: left">
          <span>{{ liquidity }} </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" style="text-align: right">
          {{ $t('Premium') }}:
        </v-col>
        <v-col style="text-align: left">
          <span>{{ premium }} </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" style="text-align: right">
          {{ $t('Your budget') }}:
        </v-col>
        <v-col style="text-align: left">
          <span>{{ budget }} </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" style="text-align: right;align-self: center">
          {{ $t('Get/set Liquidity') }}:
        </v-col>
        <v-col style="text-align: left">
          <v-text-field v-model="getSetLiquidity" style="margin-left: 10px" />
        </v-col>
      </v-row>
      <v-divider style="background: black" />
      <v-card-actions style="justify-content: center">
        <v-btn class="btn-primary" dark @click="addLiquidity">
          {{ $t('ADD LIQUIDITY') }}
        </v-btn>
        <v-btn class="btn-primary" dark @click="getLiquidity">
          {{ $t('GET LIQUIDITY') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="cardStyle"
            max-width="400" style=" margin: auto;margin-top: 10px">
      <v-card-title style="justify-content: center">
        {{ $t('Calculate price publish Byppay') }}:
      </v-card-title>
      <v-divider style="background: black" />
      <v-row>
        <v-col cols="7" style="text-align: right;align-self: center">
          {{ $t(' Byppay total amount') }}:
        </v-col>
        <v-col cols="3" style="text-align: left">
          <v-text-field v-model="initalAmount" style="margin-left: 10px" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="7" style="text-align: right;align-self: center">
          {{ $t('Collateralized amount') }} :
        </v-col>
        <v-col cols="3" style="text-align: left;">
          <v-text-field v-model="amount" style="margin-left: 10px" />
        </v-col>
      </v-row>
      <v-divider style="background: black" />
      <v-card-actions style="justify-content: center">
        <v-btn style="margin-right: 10px;" dark class="btn-primary" @click="calculatePricePublish">
          {{ $t('CALCULATE') }}
        </v-btn>
        <v-text-field v-model="calculatedPrice" readonly label="Calculated price " />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

import SmartRepository from "@/repositories/SmartRepository";
import Constants from "../../constants";
import Hash from "object-hash";

export default {
    name: "AMM",
    components: {},
    data () {
        return {
            id: "",
            liquidity: 0,
            premium: 0,
            amount: 0,
            calculatedPrice: 0,
            initalAmount: 0,
            getSetLiquidity: 0,
            budget: 0,
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            SmartRepository.call(Constants.contractAMM, "getTotalLiquidity", [])
                .then((res) => {
                    this.liquidity = SmartRepository.decodeEther(res);
                }).catch((e) => {
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
            SmartRepository.call(Constants.contractAMM, "getPremiumLiquidity", [])
                .then((res) => {
                    this.premium = SmartRepository.decodeEther(res);
                }).catch((e) => {
                    console.log("ERRROR CALL PREMIUM");
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
            SmartRepository.call(Constants.contractAMM, "getLiquidityOf", [SmartRepository.getMyAddress()])
                .then((res) => {
                    this.budget = SmartRepository.decodeEther(res);
                }).catch((e) => {
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        },
        calculatePricePublish () {
            if (this.amount > 0 && this.initalAmount > 0 ) {
                SmartRepository.call(Constants.contractAMM, "getAmount", [SmartRepository.parseEther(this.initalAmount), SmartRepository.parseEther(this.initalAmount - this.amount), SmartRepository.parseEther(this.liquidity + this.premium)])
                    .then((res) => {
                        this.calculatedPrice = SmartRepository.decodeEther(res.toString());
                    }).catch((e) => {
                        console.log("ERRROR CALL PREMIUM");
                        let message = e.toString();
                        if (e.message) {
                            message = e.message;
                        }
                        this.$root.$emit('show-snackbar', {message: message, color: "error"});
                    });
            } else if (this.amount <= 0) {
                this.$root.$emit('show-snackbar', {message: 'Amount < = 0', color: "error"});
            } else {
                this.$root.$emit('show-snackbar', {message: 'Initial amount < = 0', color: "error"});
            }
        },
        async addAllowance () {
            const res = await SmartRepository.call(Constants.contractByto, "allowance", [SmartRepository.getMyAddress(), Constants.contractAMM.address]);
            console.log(res.toString());
            if (res.toString() === '0') {
                const BN = SmartRepository.getBN();
                const maxNumber = (BN.from(2)).pow(BN.from(256)).sub(BN.from(1));
                await SmartRepository.transaction(Constants.contractByto, "increaseAllowance", [Constants.contractAMM.address, maxNumber]);
            }
        },
        async addLiquidity () {
            if (this.getSetLiquidity > 0) {
                this.$root.$emit('start-loading');
                await this.addAllowance();
                SmartRepository.transaction(Constants.contractAMM, "deposit", [SmartRepository.parseEther(this.getSetLiquidity)])
                    .then(() => {
                        this.fetch();
                        this.$root.$emit('stop-loading');
                        this.$root.$emit('show-snackbar', {message: this.$t('Add liquidity')});
                    }).catch((e) => {
                        let message = e.toString();
                        if (e.message) {
                            message = e.message;
                        }
                        this.$root.$emit('stop-loading');
                        this.$root.$emit('show-snackbar', {message: message, color: "error"});
                    });
            }  else {
                this.$root.$emit('show-snackbar', {message: this.$t('get/set liquidity >0'), color: "error"});
            }
          
        },
        async getLiquidity () {
            if (this.getSetLiquidity > 0 &&  this.liquidity > 0 && this.liquidity > this.getSetLiquidity && this.budget >= this.getSetLiquidity) {
                this.$root.$emit('start-loading');
                await this.addAllowance();
                SmartRepository.transaction(Constants.contractAMM, "withdraw", [SmartRepository.parseEther(this.getSetLiquidity)])
                    .then(() => {
                        this.fetch();
                        this.$root.$emit('stop-loading');
                        this.$root.$emit('show-snackbar', {message: this.$t('Get liquidity')});
                    }).catch((e) => {
                        let message = e.toString();
                        if (e.message) {
                            message = e.message;
                        }
                        this.$root.$emit('stop-loading');
                        this.$root.$emit('show-snackbar', {message: message, color: "error"});
                    });
            } else if (this.liquidity <= 0) {
                this.$root.$emit('show-snackbar', {message: this.$t('AMM Liquidity < = 0'), color: "error"});
            } else  if ( this.budget < this.getSetLiquidity){
                this.$root.$emit('show-snackbar', {message: this.$t('Can\'t withdraw'), color: "error"});
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('get/set liquidity >0'), color: "error"});
            }
        },
    }
};
</script>

<style scoped>

</style>
